export default __webpack_public_path__ + "static/media/FeverPoles_06.3488b4a7.png";